import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import Page from './views/Page.vue'
import Homepage from './views/Homepage.vue'
import Magazine from './views/Magazine.vue'
import Article from './components/Article.vue'
import Post from './views/Post.vue'
import News from './views/News.vue'
import Telethon from './views/Telethon.vue'
import Broadcast from './views/Broadcast.vue';
import RadicalBroadcast from './components/RadicalBroadcast.vue'
import Search from './views/Search.vue';
import Meta from 'vue-meta'

Vue.use( Router )
Vue.use( Meta )

export default new Router({
  mode: 'history',
  routes: [
	  {
	    path: '/:_(2008|2009|2010|2011|2012|2013|2014|2015|2016|2017|2018)/(:foo/:bar/:caw)?*',
	    redirect: { name: 'news' }
	  },
    {
      path: '/',
	    name: 'homepage',
      component: Homepage
    },
    {
      path: '/magazine',
      name: 'magazine',
      component: Magazine
    },
    {
      path: '/news/:postId',
      name: 'post',
      component: Post
    },
    {
	    path: '/news/item/:postId',
      redirect: '/news'
	  },
	  {
	    path: '/news-events',
      redirect: '/news'
	  },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/404',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/do-not-enter-or-modify-or-erase/*',
      redirect: '/404'
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '/magazine/:articleId',
      name: 'article',
      component: Article
    },
    {
      path: '/magazine/by-tag/*',
      redirect: '/magazine'
    },
    {
      path: '/magazine/category/*',
      redirect: '/magazine'
    },
    {
      path: '/blog',
      redirect: '/magazine'
    },
    {
	    path: '/magazine/entry/:articleId',
      redirect: '/magazine/:articleId'
	  },
	  {
	    path: '/category/*',
      redirect: '/magazine'
	  },
    {
	    path: '/blog/*',
      redirect: '/magazine'
	  },
    {
	    path: '/about/jobs',
      redirect: '/jobs'
	  },
	  {
	    path: '/wowbenefit/*',
      redirect: '/'
	  },
	  {
	    path: '/event/*',
      redirect: '/'
    },
    {
      path: '/telethon',
      // component: Telethon
      component: Broadcast
    },
    {
      path: '/broadcast',
      component: Broadcast
    },
    {
      path: '/search/:searchTerm',
      name: 'search',
      component: Search
    },
    {
      path: '/:uid/:active_section?',
      name: 'page',
      component: Page,
      props: true
    },
    
    {
      path: '*',
      redirect: { name: 'not-found' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
	  return { x: 0, y: 0 }
	}
})
